import { Image } from '@skytech/ui/Image'
import { connect } from 'react-redux'

import { increaseStep, toggleProduct } from '@/ducks/onboarding/onboardingActions'
import { getAccessories, isProductSelected } from '@/ducks/onboarding/onboardingSelectors'
import { numberFormat } from '@/util/formatters/numbers'
import {
  OnboardingNextStepIcon,
  OnboardingNotSelectedIcon,
  OnboardingSelectedIcon,
} from '@/util/icons'

import './step-accessories.scss'

const StepAccessories = ({ products, isProductSelected, toggleProduct, increaseStep }: any) => (
  <div id="step-accessories" className="step">
    <h3>Select Accessories</h3>

    <div className="products">
      {/* @ts-ignore */}

      {products.map(({ id, ...restOfProps }) => (
        // @ts-ignore

        <Product
          key={id}
          toggleProduct={toggleProduct}
          isProductSelected={isProductSelected(id)}
          id={id}
          {...restOfProps}
        />
      ))}
    </div>

    <button onClick={increaseStep}>
      Confirm order
      <OnboardingNextStepIcon />
    </button>
  </div>
)

const Product = ({ id, name, price, imgUrl, toggleProduct, isProductSelected }: any) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    onClick={() => toggleProduct(id)}
    className={`products__product ${isProductSelected && 'selected'}`}
  >
    <h3>{name}</h3>

    <div className="selection">
      {isProductSelected ? <OnboardingSelectedIcon /> : <OnboardingNotSelectedIcon />}
    </div>

    <Image src={imgUrl} alt="product" />

    <div className="price">
      Price: <b>{numberFormat(price)},-</b>
    </div>
  </div>
)

// @ts-ignore
const mapStateToProps = state => ({
  products: getAccessories(state),
  // @ts-ignore
  isProductSelected: pid => isProductSelected(state, pid),
})

const mapDispatchToProps = {
  toggleProduct,
  increaseStep,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepAccessories)
